import React from 'react';

const Button = props => (
    <button className={`btn ${props.classes}`} onClick={e => props.onClick(e)}>
        {props.text}
    </button>
);

export default Button;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/button.js